import { BasicRenderer } from "./basic-renderer-component"
import { HTMLRenderer } from "./html-renderer-component"
import { MarkdownRenderer } from "./markdown-renderer-component"

const richTextRenderers = { BasicRenderer, HTMLRenderer, MarkdownRenderer }

export { richTextRenderers }
